import React, { Key } from 'react';
import { notification } from 'antd';
import { ArgsProps } from 'antd/es/notification/interface';
import { SvgIcon } from '../../../../lib/components/SvgIcon/SvgIcon';
import { ISvgIconName } from '../../../../lib/components/SvgIcon/interfaces/SvgIconNames';

export type ToastType = 'error' | 'info' | 'success' | 'warning' | 'loading';

const TYPE_CONFIG: Record<ToastType, { iconName: ISvgIconName }> = {
  error: { iconName: 'warningCritical' },
  info: { iconName: 'information' },
  loading: { iconName: 'loading' },
  success: { iconName: 'check' },
  warning: { iconName: 'warn' },
};

const getIcon = (type: ToastType, customIcon?: React.ReactNode): React.ReactNode => {
  if (customIcon !== undefined) return customIcon;
  const { iconName } = TYPE_CONFIG[type];
  return (
    <span
      style={{
        color: '#FFFFFF',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <SvgIcon name={iconName} />
    </span>
  );
};

const closeIcon = (
  <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <SvgIcon name="cancel" />
  </span>
);

const open = (type: ToastType, props: ArgsProps): void => {
  const typeClass = `kcc-toast--${type}`;
  notification.open({
    closable: false,
    ...props,
    className: props.className ? `kcc-toast ${typeClass} ${props.className}` : `kcc-toast ${typeClass}`,
    icon: getIcon(type, props.icon),
    closeIcon: props.closeIcon ?? closeIcon,
  });
};

export const toast = {
  error: (props: ArgsProps): void => open('error', props),
  info: (props: ArgsProps): void => open('info', props),
  success: (props: ArgsProps): void => open('success', props),
  warning: (props: ArgsProps): void => open('warning', props),
  loading: (props: ArgsProps): void => open('loading', props),
  close: (key: Key): void => notification.destroy(key),
};
